/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { put, select, takeLatest } from 'redux-saga/effects';

import { getRouteVar } from '@nebula/rover';
import { SESSION_VIEW } from '../../casing/data/pages';
import { applySettings } from '../../session-view/actions';
import * as T from '../actions';
import { selectSelectedWorkspace } from '../selectors';
import { activeWorkspace } from '../../casing/data/prefabs';

export function* handleSelectWorkspace() {
  const selectedWorkspace = yield select(selectSelectedWorkspace);
  yield put(activeWorkspace.changeAction(selectedWorkspace.id));

  const page = yield select(getRouteVar('page'));
  if (page === SESSION_VIEW) {
    yield put(applySettings());
  }
}

export function* watchSelectWorkspace() {
  yield takeLatest(T.SELECT_WORKSPACE, handleSelectWorkspace);
}
